import clsx from 'clsx';
import React from 'react';
import { withTranslation } from 'react-i18next';

const InputPrintPoints = ({ t, size, pointsTotal }) => {
  return (
    <div className={clsx(`input-points input-print-options input-points--size-${size}`)}>
      <div className={clsx('input-points__input-container')}>
        <div className="input-points__empty-space" />
        <label className="input-points__points-total">
          /{pointsTotal} {!isNaN(pointsTotal) ? (pointsTotal === 1 ? t('point') : t('points')) : ' '}
        </label>
      </div>
    </div>
  );
};

export default withTranslation(['common'])(InputPrintPoints);
